import { render, staticRenderFns } from "./Eye-protection-experts.vue?vue&type=template&id=e8f0d500&"
import script from "./Eye-protection-experts.vue?vue&type=script&lang=js&"
export * from "./Eye-protection-experts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports